import React from 'react';
import { CreateBasketPayload } from '../../../../datasources/baskets/BasketsDataSource';
import { DialogBasket } from './dialogBasket';

type CreateBasketDialogProps = {
  open: boolean;
  onClose: () => void;
  loading?: boolean;
  error?: string;
  progress?: number;
  canConfirm?: boolean;
  onConfirm?: (payload: CreateBasketPayload) => void | Promise<void>;
};

export const CreateBasketDialog: React.FC<CreateBasketDialogProps> = (
  props
) => <DialogBasket {...props} mode="create" />;
